import iconAddDark from '../../../assets/lottie/add_dark.tgs';
import iconAddLight from '../../../assets/lottie/add_light.tgs';
import iconAgentDark from '../../../assets/lottie/agent_dark.tgs';
import iconAgentLight from '../../../assets/lottie/agent_light.tgs';
import iconAgentSolidDark from '../../../assets/lottie/agent_solid_dark.tgs';
import iconAgentSolidLight from '../../../assets/lottie/agent_solid_light.tgs';
import iconBuyDark from '../../../assets/lottie/buy_dark.tgs';
import iconBuyLight from '../../../assets/lottie/buy_light.tgs';
import iconClockDark from '../../../assets/lottie/clock_dark.tgs';
import iconClockDarkBlue from '../../../assets/lottie/clock_dark_blue.tgs';
import iconClockDarkGray from '../../../assets/lottie/clock_dark_gray.tgs';
import iconClockDarkGreen from '../../../assets/lottie/clock_dark_green.tgs';
import iconClockDarkOrange from '../../../assets/lottie/clock_dark_orange.tgs';
import iconClockDarkPurple from '../../../assets/lottie/clock_dark_purple.tgs';
import iconClockDarkPurpleWhite from '../../../assets/lottie/clock_dark_purple_white.tgs';
import iconClockDarkRed from '../../../assets/lottie/clock_dark_red.tgs';
import iconClockLight from '../../../assets/lottie/clock_light.tgs';
import iconClockLightBlue from '../../../assets/lottie/clock_light_blue.tgs';
import iconClockLightGray from '../../../assets/lottie/clock_light_gray.tgs';
import iconClockLightGreen from '../../../assets/lottie/clock_light_green.tgs';
import iconClockLightOrange from '../../../assets/lottie/clock_light_orange.tgs';
import iconClockLightPurple from '../../../assets/lottie/clock_light_purple.tgs';
import iconClockLightPurpleWhite from '../../../assets/lottie/clock_light_purple_white.tgs';
import iconClockLightRed from '../../../assets/lottie/clock_light_red.tgs';
import bill from '../../../assets/lottie/duck_bill.tgs';
import forge from '../../../assets/lottie/duck_forges.tgs';
import guard from '../../../assets/lottie/duck_guard.tgs';
import happy from '../../../assets/lottie/duck_happy.tgs';
import hello from '../../../assets/lottie/duck_hello.tgs';
import noData from '../../../assets/lottie/duck_no-data.tgs';
import run from '../../../assets/lottie/duck_run.tgs';
import snitch from '../../../assets/lottie/duck_snitch.tgs';
import thumbUp from '../../../assets/lottie/duck_thumb.tgs';
import holdTon from '../../../assets/lottie/duck_ton.tgs';
import wait from '../../../assets/lottie/duck_wait.tgs';
import yeee from '../../../assets/lottie/duck_yeee.tgs';
import iconEarnDark from '../../../assets/lottie/earn_dark.tgs';
import iconEarnDarkPurple from '../../../assets/lottie/earn_dark_purple.tgs';
import iconEarnLight from '../../../assets/lottie/earn_light.tgs';
import iconEarnLightPurple from '../../../assets/lottie/earn_light_purple.tgs';
import iconExploreDark from '../../../assets/lottie/explore_dark.tgs';
import iconExploreLight from '../../../assets/lottie/explore_light.tgs';
import iconExploreSolidDark from '../../../assets/lottie/explore_solid_dark.tgs';
import iconExploreSolidLight from '../../../assets/lottie/explore_solid_light.tgs';
import iconMarketDark from '../../../assets/lottie/market_dark.tgs';
import iconMarketLight from '../../../assets/lottie/market_light.tgs';
import iconMarketSolidDark from '../../../assets/lottie/market_solid_dark.tgs';
import iconMarketSolidLight from '../../../assets/lottie/market_solid_light.tgs';
import iconSellDark from '../../../assets/lottie/sell_dark.tgs';
import iconSellLight from '../../../assets/lottie/sell_light.tgs';
import iconSendDark from '../../../assets/lottie/send_dark.tgs';
import iconSendLight from '../../../assets/lottie/send_light.tgs';
import iconSettingsDark from '../../../assets/lottie/settings_dark.tgs';
import iconSettingsLight from '../../../assets/lottie/settings_light.tgs';
import iconSettingsSolidDark from '../../../assets/lottie/settings_solid_dark.tgs';
import iconSettingsSolidLight from '../../../assets/lottie/settings_solid_light.tgs';
import iconSwapDark from '../../../assets/lottie/swap_dark.tgs';
import iconSwapLight from '../../../assets/lottie/swap_light.tgs';
import iconWalletDark from '../../../assets/lottie/wallet_dark.tgs';
import iconWalletLight from '../../../assets/lottie/wallet_light.tgs';
import iconWalletSolidDark from '../../../assets/lottie/wallet_solid_dark.tgs';
import iconWalletSolidLight from '../../../assets/lottie/wallet_solid_light.tgs';
import iconAddPreviewDark from '../../../assets/lottiePreview/add_dark.png';
import iconAddPreviewLight from '../../../assets/lottiePreview/add_light.png';
import iconAgentPreviewDark from '../../../assets/lottiePreview/agent_dark.png';
import iconAgentPreviewLight from '../../../assets/lottiePreview/agent_light.png';
import iconAgentSolidPreviewDark from '../../../assets/lottiePreview/agent_solid_dark.png';
import iconAgentSolidPreviewLight from '../../../assets/lottiePreview/agent_solid_light.png';
import iconBuyPreviewDark from '../../../assets/lottiePreview/buy_dark.png';
import iconBuyPreviewLight from '../../../assets/lottiePreview/buy_light.png';
import iconClockPreviewDark from '../../../assets/lottiePreview/clock_dark.svg';
import iconClockPreviewDarkBlue from '../../../assets/lottiePreview/clock_dark_blue.svg';
import iconClockPreviewDarkGray from '../../../assets/lottiePreview/clock_dark_gray.svg';
import iconClockPreviewDarkGreen from '../../../assets/lottiePreview/clock_dark_green.svg';
import iconClockPreviewDarkOrange from '../../../assets/lottiePreview/clock_dark_orange.svg';
import iconClockPreviewDarkPurple from '../../../assets/lottiePreview/clock_dark_purple.svg';
import iconClockPreviewDarkPurpleWhite from '../../../assets/lottiePreview/clock_dark_purple_white.svg';
import iconClockPreviewDarkRed from '../../../assets/lottiePreview/clock_dark_red.svg';
import iconClockPreviewLight from '../../../assets/lottiePreview/clock_light.svg';
import iconClockPreviewLightBlue from '../../../assets/lottiePreview/clock_light_blue.svg';
import iconClockPreviewLightGray from '../../../assets/lottiePreview/clock_light_gray.svg';
import iconClockPreviewLightGreen from '../../../assets/lottiePreview/clock_light_green.svg';
import iconClockPreviewLightOrange from '../../../assets/lottiePreview/clock_light_orange.svg';
import iconClockPreviewLightPurple from '../../../assets/lottiePreview/clock_light_purple.svg';
import iconClockPreviewLightPurpleWhite from '../../../assets/lottiePreview/clock_light_purple_white.svg';
import iconClockPreviewLightRed from '../../../assets/lottiePreview/clock_light_red.svg';
import billPreview from '../../../assets/lottiePreview/duck_bill.png';
import forgePreview from '../../../assets/lottiePreview/duck_forges.png';
import guardPreview from '../../../assets/lottiePreview/duck_guard.png';
import happyPreview from '../../../assets/lottiePreview/duck_happy.png';
import helloPreview from '../../../assets/lottiePreview/duck_hello.png';
import noDataPreview from '../../../assets/lottiePreview/duck_no-data.png';
import runPreview from '../../../assets/lottiePreview/duck_run.png';
import snitchPreview from '../../../assets/lottiePreview/duck_snitch.png';
import thumbUpPreview from '../../../assets/lottiePreview/duck_thumb.png';
import holdTonPreview from '../../../assets/lottiePreview/duck_ton.png';
import waitPreview from '../../../assets/lottiePreview/duck_wait.png';
import yeeePreview from '../../../assets/lottiePreview/duck_yeee.png';
import iconEarnPreviewDark from '../../../assets/lottiePreview/earn_dark.png';
import iconEarnPreviewDarkPurple from '../../../assets/lottiePreview/earn_dark_purple.png';
import iconEarnPreviewLight from '../../../assets/lottiePreview/earn_light.png';
import iconEarnPreviewLightPurple from '../../../assets/lottiePreview/earn_light_purple.png';
import iconExplorePreviewDark from '../../../assets/lottiePreview/explore_dark.png';
import iconExplorePreviewLight from '../../../assets/lottiePreview/explore_light.png';
import iconExploreSolidPreviewDark from '../../../assets/lottiePreview/explore_solid_dark.png';
import iconExploreSolidPreviewLight from '../../../assets/lottiePreview/explore_solid_light.png';
import iconMarketPreviewDark from '../../../assets/lottiePreview/market_dark.png';
import iconMarketPreviewLight from '../../../assets/lottiePreview/market_light.png';
import iconMarketSolidPreviewDark from '../../../assets/lottiePreview/market_solid_dark.png';
import iconMarketSolidPreviewLight from '../../../assets/lottiePreview/market_solid_light.png';
import iconSellPreviewDark from '../../../assets/lottiePreview/sell_dark.png';
import iconSellPreviewLight from '../../../assets/lottiePreview/sell_light.png';
import iconSendPreviewDark from '../../../assets/lottiePreview/send_dark.png';
import iconSendPreviewLight from '../../../assets/lottiePreview/send_light.png';
import iconSettingsPreviewDark from '../../../assets/lottiePreview/settings_dark.png';
import iconSettingsPreviewLight from '../../../assets/lottiePreview/settings_light.png';
import iconSettingsSolidPreviewDark from '../../../assets/lottiePreview/settings_solid_dark.png';
import iconSettingsSolidPreviewLight from '../../../assets/lottiePreview/settings_solid_light.png';
import iconSwapPreviewDark from '../../../assets/lottiePreview/swap_dark.png';
import iconSwapPreviewLight from '../../../assets/lottiePreview/swap_light.png';
import iconWalletPreviewDark from '../../../assets/lottiePreview/wallet_dark.png';
import iconWalletPreviewLight from '../../../assets/lottiePreview/wallet_light.png';
import iconWalletSolidPreviewDark from '../../../assets/lottiePreview/wallet_solid_dark.png';
import iconWalletSolidPreviewLight from '../../../assets/lottiePreview/wallet_solid_light.png';

export const ANIMATED_STICKERS_PATHS = {
  hello,
  snitch,
  bill,
  thumbUp,
  holdTon,
  happy,
  noData,
  forge,
  wait,
  run,
  yeee,
  guard,
  helloPreview,
  snitchPreview,
  billPreview,
  thumbUpPreview,
  holdTonPreview,
  happyPreview,
  noDataPreview,
  forgePreview,
  waitPreview,
  runPreview,
  yeeePreview,
  guardPreview,
  light: {
    iconAdd: iconAddLight,
    iconAgent: iconAgentLight,
    iconAgentSolid: iconAgentSolidLight,
    iconBuy: iconBuyLight,
    iconClock: iconClockLight,
    iconClockBlue: iconClockLightBlue,
    iconClockGray: iconClockLightGray,
    iconClockGreen: iconClockLightGreen,
    iconClockOrange: iconClockLightOrange,
    iconClockPurple: iconClockLightPurple,
    iconClockPurpleWhite: iconClockLightPurpleWhite,
    iconClockRed: iconClockLightRed,
    iconEarn: iconEarnLight,
    iconEarnPurple: iconEarnLightPurple,
    iconExplore: iconExploreLight,
    iconExploreSolid: iconExploreSolidLight,
    iconMarket: iconMarketLight,
    iconMarketSolid: iconMarketSolidLight,
    iconSell: iconSellLight,
    iconSend: iconSendLight,
    iconSettings: iconSettingsLight,
    iconSettingsSolid: iconSettingsSolidLight,
    iconSwap: iconSwapLight,
    iconWallet: iconWalletLight,
    iconWalletSolid: iconWalletSolidLight,
    preview: {
      iconAdd: iconAddPreviewLight,
      iconAgent: iconAgentPreviewLight,
      iconAgentSolid: iconAgentSolidPreviewLight,
      iconBuy: iconBuyPreviewLight,
      iconClock: iconClockPreviewLight,
      iconClockBlue: iconClockPreviewLightBlue,
      iconClockGray: iconClockPreviewLightGray,
      iconClockGreen: iconClockPreviewLightGreen,
      iconClockOrange: iconClockPreviewLightOrange,
      iconClockPurple: iconClockPreviewLightPurple,
      iconClockPurpleWhite: iconClockPreviewLightPurpleWhite,
      iconClockRed: iconClockPreviewLightRed,
      iconEarn: iconEarnPreviewLight,
      iconEarnPurple: iconEarnPreviewLightPurple,
      iconExplore: iconExplorePreviewLight,
      iconExploreSolid: iconExploreSolidPreviewLight,
      iconMarket: iconMarketPreviewLight,
      iconMarketSolid: iconMarketSolidPreviewLight,
      iconSell: iconSellPreviewLight,
      iconSend: iconSendPreviewLight,
      iconSettings: iconSettingsPreviewLight,
      iconSettingsSolid: iconSettingsSolidPreviewLight,
      iconSwap: iconSwapPreviewLight,
      iconWallet: iconWalletPreviewLight,
      iconWalletSolid: iconWalletSolidPreviewLight,
    },
  },
  dark: {
    iconAdd: iconAddDark,
    iconAgent: iconAgentDark,
    iconAgentSolid: iconAgentSolidDark,
    iconBuy: iconBuyDark,
    iconClock: iconClockDark,
    iconClockBlue: iconClockDarkBlue,
    iconClockGray: iconClockDarkGray,
    iconClockGreen: iconClockDarkGreen,
    iconClockOrange: iconClockDarkOrange,
    iconClockPurple: iconClockDarkPurple,
    iconClockPurpleWhite: iconClockDarkPurpleWhite,
    iconClockRed: iconClockDarkRed,
    iconEarn: iconEarnDark,
    iconEarnPurple: iconEarnDarkPurple,
    iconExplore: iconExploreDark,
    iconExploreSolid: iconExploreSolidDark,
    iconMarket: iconMarketDark,
    iconMarketSolid: iconMarketSolidDark,
    iconSell: iconSellDark,
    iconSend: iconSendDark,
    iconSettings: iconSettingsDark,
    iconSettingsSolid: iconSettingsSolidDark,
    iconSwap: iconSwapDark,
    iconWallet: iconWalletDark,
    iconWalletSolid: iconWalletSolidDark,
    preview: {
      iconAdd: iconAddPreviewDark,
      iconAgent: iconAgentPreviewDark,
      iconAgentSolid: iconAgentSolidPreviewDark,
      iconBuy: iconBuyPreviewDark,
      iconClock: iconClockPreviewDark,
      iconClockBlue: iconClockPreviewDarkBlue,
      iconClockGray: iconClockPreviewDarkGray,
      iconClockGreen: iconClockPreviewDarkGreen,
      iconClockOrange: iconClockPreviewDarkOrange,
      iconClockPurple: iconClockPreviewDarkPurple,
      iconClockPurpleWhite: iconClockPreviewDarkPurpleWhite,
      iconClockRed: iconClockPreviewDarkRed,
      iconEarn: iconEarnPreviewDark,
      iconEarnPurple: iconEarnPreviewDarkPurple,
      iconExplore: iconExplorePreviewDark,
      iconExploreSolid: iconExploreSolidPreviewDark,
      iconMarket: iconMarketPreviewDark,
      iconMarketSolid: iconMarketSolidPreviewDark,
      iconSell: iconSellPreviewDark,
      iconSend: iconSendPreviewDark,
      iconSettings: iconSettingsPreviewDark,
      iconSettingsSolid: iconSettingsSolidPreviewDark,
      iconSwap: iconSwapPreviewDark,
      iconWallet: iconWalletPreviewDark,
      iconWalletSolid: iconWalletSolidPreviewDark,
    },
  },
};
